import * as React from 'react';

import CampaignAchievementsStatsCard from './CampaignAchievementsStatsCard';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./campaign-achievements-stats.i18n.json'));

const CampaignAchievementsDefaultStats = (): JSX.Element => (
  <section className="campaign-achievements-stats">
    <h2 className="campaign-achievements-stats__title">
      {__t('campaign_achievements_stats.title')}
    </h2>
    <section className="campaign-achievements-stats-items">
      <CampaignAchievementsStatsCard
        key="campaign-achievements-stats-total-content-creators"
        id="total_content_creators"
        label={__t('campaign_achievements_stats.total_content_creators')}
      />
      <CampaignAchievementsStatsCard
        key="campaign-achievements-total-posts"
        id="total_posts"
        label={__t('campaign_achievements_stats.total_posts')}
      />
      <CampaignAchievementsStatsCard
        key="campaign-achievements-cost-per-post"
        id="cost_per_post"
        label={__t('campaign_achievements_stats.cost_per_post')}
      />
      <CampaignAchievementsStatsCard
        key="campaign-achievements-followers-reached"
        id="followers_reached"
        label={__t('campaign_achievements_stats.followers_reached')}
      />
    </section>
  </section>
);

export default CampaignAchievementsDefaultStats;
